<template>
    <div class="home_component">
        <router-view></router-view>
        <Tabbar v-model="active" active-color="#6A94ED">
            <TabbarItem :to="{name:tabBarList[0].name}" >
                <span>{{tabBarList[0].text}}</span>
                <template #icon="props">
                    <img :src="props.active?tabBarList[0].iconactive:tabBarList[0].icon" alt="">
                </template>
            </TabbarItem>
            <TabbarItem :to="{name:tabBarList[1].name}" >
                <span>{{tabBarList[1].text}}</span>
                <template #icon="props">
                    <img :src="props.active?tabBarList[1].iconactive:tabBarList[1].icon" alt="">
                </template>
            </TabbarItem>
            <TabbarItem  replace @click="jumpUrl(2)">
                <template #icon="props">
                    <img :src="props.active?tabBarList[2].iconactive:tabBarList[2].icon" alt="" style="width: 1rem;height: 1rem;">
                </template>
            </TabbarItem>
            <TabbarItem :to="{name:tabBarList[3].name}"  >
                <span>{{tabBarList[3].text}}</span>
                <template #icon="props">
                    <img :src="props.active?tabBarList[3].iconactive:tabBarList[3].icon" alt="">
                </template>
            </TabbarItem>
            <TabbarItem :to="{name:tabBarList[4].name}" >
                <span>{{tabBarList[4].text}}</span>
                <template #icon="props">
                    <img :src="props.active?tabBarList[4].iconactive:tabBarList[4].icon" alt="">
                </template>
            </TabbarItem>
        </Tabbar>
        <!-- <van-popup v-model="show" :close-on-click-overlay="false" closeable close-icon="close"  :style="{ height: 'auto','background-color':'transparent' }">
            <div class="signwrapper">                
                <div class="block">
                    <div class="block_header">
                        <div>已连续登录<span>{{continuity}}</span>天，连续签到10天可<br/>多领取5个健康值哦！</div>
                    </div>
                    <div class="block_body">
                        <div class="html">{{signpoint}}</div>                                             
                    </div>  
                    <div class="footer">
                        <div class="mvbutton home" @click="receive">
                            领取健康值
                        </div>
                        <div class="notice">*每日只可领取一次</div>
                    </div>                    
                </div>                
            </div>
        </van-popup> -->
    </div>
</template>

<script>
    import './_home.less'
    import {Tabbar, TabbarItem,Popup} from 'vant';
    import utils from 'libs/utils'
    import storage from 'libs/storage'
    export default {
        name: 'HomeL',
        watch:{
          '$route.name':function(e){
              this.activeItem(e);
          }
        },
        methods:{
            jumpUrl(index)
            {
                storage.get('userInfo').then(res=>{
                    if(res.role == 30)
                        this.$router.push({name:'resume'});
                    else
                        this.$router.push({name:'recruit'});
                })
            },
            activeItem(e){
              this.tabBarList.forEach((item,index)=>{
                  if(item.name==e){
                      this.active    =   index;
                  }
              })                    
            },
            receive(){
                this.$api.user.signinh5().then(res=>{
                    if(res.status*1===200){
                        this.show = false;
                        this.$toast.success('提交成功！');                        
                    }
                })
            },
//            getUserInfo() {
//                this.$api.user.getUserInfo().then((res) => {
//                    if (res.status * 1 === 200) {
//                        let userinfo = res.data;
//                        console.log(userinfo,'userinfo')
//                        this.continuity = userinfo.continuity
//                        this.signpoint = userinfo.signpoint
//                        if(userinfo.issign==0&&userinfo.isshow) this.show = true;
//                    }
//                })
//            }
        },
        components: {
            Tabbar,
            TabbarItem,
            vanPopup:Popup
        },
        data() {
            return {
                active: 0,
                tabBarList: [
                    {
                        name: "exchange",
                        icon: require('assets/img/common/tabbar/huodong.png'),
                        iconactive: require('assets/img/common/tabbar/huodonga.png'),
                        text: '首页',
                    },
                    {
                        name: "information",
                        icon: require('assets/img/common/tabbar/infor.png'),
                        iconactive: require('assets/img/common/tabbar/infora.png'),
                        text: '资讯',
                    },
                    {
                        name: "recruit",
                        icon: require('assets/img/common/tabbar/add.png'),
                        iconactive: require('assets/img/common/tabbar/add.png'),
                        text: '',
                    },
                    {
                        name: "news",
                        icon: require('assets/img/common/tabbar/news.png'),
                        iconactive: require('assets/img/common/tabbar/newsa.png'),
                        text: '消息',
                    },
                    // {
                    //     name: "index",
                    //     icon: require('assets/img/common/tabbar/duihuan.png'),
                    //     iconactive: require('assets/img/common/tabbar/duihuana.png'),
                    //     text: '兑换',
                    // },  
                    {
                        name: "my",
                        icon: require('assets/img/common/tabbar/my.png'),
                        iconactive: require('assets/img/common/tabbar/mya.png'),
                        text: '我的',
                    }
                ],
                show:false,
                continuity:0,
                signpoint:0
            }
        },
        mounted() {
            this.$nextTick(()=>{
              this.activeItem(this.$route.name);  
//               this.getUserInfo();
            })
        }
    }
</script>
